import { useContext, useEffect, useState } from "react";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDProgress from "components/MDProgress";

import { LanguageContext } from "context";

import { type PlanProgress } from "@shared/api/tasks";

function ProgressDashboard({ data }: { data: PlanProgress[] }) {
  const { t } = useContext(LanguageContext) as any;

  const formatDecimal = (value: number | string, digits: number): number  => {
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return 0;
    const factor = Math.pow(10, digits);
    return Math.round(num * factor) / factor;
  }

  return (
    <MDBox>
      {data.map((plan) => {
        const percent = plan.total > 0 ? (plan.completed / plan.total) * 100 : 0;
        return (
          <MDBox key={plan.id} mb={3}>
            <MDTypography variant="body2" fontWeight="bold" mt={1}>
              {plan.title}: {percent.toFixed(0)}%
            </MDTypography>
            <MDBox mt={1} mb={1}>
              <MDProgress value={formatDecimal(percent, 1)} color="info" label />
            </MDBox>
            <MDTypography variant="body2">
              {t("ProgressDashboard.title2")}
              {plan.completed}/{plan.total}
            </MDTypography>
          </MDBox>
        );
      })}
    </MDBox>
  );
}

export default ProgressDashboard;
